export function filtruotiChip(ats = [], filterMain = {}) {
    // Patikriname ar turime ką filtruoti
    if (!Array.isArray(ats) || ats.length === 0) {
        return []; // Grąžiname tuščią masyvą jei nėra duomenų
    }

    const filteredAts = ats.filter(atsItem => {
        const answerData = atsItem?.attributes?.atsakymai;

        // Jei nėra atsakymų duomenų, praleidžiame
        if (!answerData) {
            return false;
        }

        // Tikriname ar atitinka visus filtrus
        const allFiltersMatch = Object.keys(filterMain).every(filterKey => {
            const filterValues = filterMain[filterKey];
            const answerValue = answerData[filterKey];

            // Jei filtro reikšmės tuščios arba atsakymo reikšmė yra įtraukta, filtras atitinka
            return !filterValues || filterValues.length === 0 || filterValues.includes(answerValue);
        });

        return allFiltersMatch;
    });

    // Pašaliname dublikatus pagal ID
    return filteredAts.filter((object, index, self) =>
        index === self.findIndex(obj => obj.id === object.id)
    );
}